module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp1_3016.9c3ff4ba.png";